import { RangeCalendarGridRow_default } from "../RangeCalendar/RangeCalendarGridRow.js";
import { createBlock, defineComponent, guardReactiveProps, normalizeProps, openBlock, renderSlot, unref, withCtx } from "vue";

//#region src/DateRangePicker/DateRangePickerGridRow.vue?vue&type=script&setup=true&lang.ts
var DateRangePickerGridRow_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
	__name: "DateRangePickerGridRow",
	props: {
		asChild: {
			type: Boolean,
			required: false
		},
		as: {
			type: null,
			required: false
		}
	},
	setup(__props) {
		const props = __props;
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(RangeCalendarGridRow_default), normalizeProps(guardReactiveProps(props)), {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 16);
		};
	}
});

//#endregion
//#region src/DateRangePicker/DateRangePickerGridRow.vue
var DateRangePickerGridRow_default = DateRangePickerGridRow_vue_vue_type_script_setup_true_lang_default;

//#endregion
export { DateRangePickerGridRow_default };
//# sourceMappingURL=DateRangePickerGridRow.js.map